// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"254":"0d161900","346":"a8ed3021","348":"2f751c09","489":"4920c4b0","641":"3fafa879","695":"e48f6564","723":"a4a3c5ef","893":"b94e65b6"}[chunkId] + ".chunk.css";
};